//#region Imports
import React, { useState, useEffect } from 'react';
import { StyleSheet, Pressable, SafeAreaView, View, SectionList, Image, Platform, useWindowDimensions, FlatList, ActivityIndicator } from 'react-native';
import { Card } from 'react-native-paper';
import { showMessage } from "react-native-flash-message";
import CustomProgressCircle from '../../../components/CustomProgressCircle/CustomProgressCircle';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { useSettingsContext } from '../../../hooks/useSettingsContext';
import { useTheme, useNavigation } from '@react-navigation/native';
import { useSignin } from '../../../hooks/useSignIn';
import { useTranslation } from 'react-i18next';
import * as Progress from 'react-native-progress';
import axios from 'axios';
import { DEFAULTPROFILE } from '../../../img/DefaultProfile';
import { useSafeAreaInsets } from "react-native-safe-area-context";
//#endregion

const TeamsLeaveBalancesScreen = () => {

    //#region Function State Definitions
    const [data, setdata] = useState([])
    const { t, i18n } = useTranslation();
    const navigation = useNavigation();
    const [loading, setLoading] = useState(false)
    const { username, user, dispatch, clientApi } = useAuthContext();
    const { isAlphaMega } = useSettingsContext();
    const { oasisParam } = useAccountContext();
    const { colors } = useTheme();
    const { refreshSignIn } = useSignin();
    const { width, height } = useWindowDimensions();
    const styles = makeStyles(colors, width, height)
    const [teamMemberData, setTeamMemberData] = useState([]);
    const [selectedTitle, setSelectedTitle] = useState("")
    const [expandedSections, setExpandedSections] = useState(new Set());
    const insets = useSafeAreaInsets();
    //#endregion

    //#region API Calls
    const GetTeamsLeaveAnalysis = async () => {
        setLoading(true);

        await axios.get(`${clientApi}api/Employee/PersonalLeaveBalancesTeam`, {
            headers: { Authorization: `Bearer ${user.token}` },
            params: {
                username: username
            }
        })
            .then((response) => {
                setdata(response.data)
                // update loading state
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                if (error.response.status === 401) {
                    refreshSignIn(user, clientapi)
                } else if (error.response.status === 400) {
                    showMessage({
                        message: error.request.response,
                        type: "danger",
                        duration: 5000,
                        position: "top",
                        ...(Platform.OS === 'web' ? {} : { style: { marginTop: insets.top + 16 }}),
                        ...(Platform.OS === 'web' ? {}  : {floating: true,})
                    });
                };
                console.log(error.message);
            });
    }
    //#endregion

    //#region Listeners
    const handleToggle = (title) => {
        {
            Platform.OS === 'web' &&
                setTeamMemberData([])
            data.forEach(function (d) {
                if (d.employeeName === title) {
                    setTeamMemberData(d.data)
                }
            })


        }
        setSelectedTitle(title);
        setExpandedSections((expandedSections) => {
            // Using Set here but you can use an array too
            const next = new Set(expandedSections);
            if (next.has(title)) {
                next.delete(title);
            } else {
                next.add(title);
            }
            return next;
        });
    };

    const ShowHideMenu = (item) => {
        const [showDetails, setShowDetails] = useState((Platform.OS === 'web' && width > 1200) ? true : false);

        const onShowHidePress = (item) => {
            setShowDetails((Platform.OS === 'web' && width > 1200) ? true : !showDetails);
        }
        let totalAllowance = (item.yearlyAllowance + item.broughtforward) - item.broughtforwardExpired
        totalAllowance = totalAllowance || 0
        let leavePercent = (item.remaining * 100) / totalAllowance
        leavePercent = leavePercent || 100
        let tot = item.remaining + ' / ' + totalAllowance
        leavePercent = isFinite(leavePercent) ? leavePercent : 100;

        return (
            <View style={styles.showhide}>
                <SafeAreaView style={styles.columnLeft}>
                    <Pressable onPress={() => onShowHidePress(item)}>
                        {totalAllowance !== 0 ?
                            <CustomLabel
                                value={tot + " " + t('common:leaveUnit', { leaveUnit: i18n.language === "gr" ? oasisParam.leaveUnit === "H" ? "ώρες" : "ημέρες" : oasisParam.leaveUnit === "H" ? "hours" : "days" })}
                                type='AVAILABLEUSED' /> :
                            <CustomLabel
                                value={item.remaining + " " + t('common:leaveUnit', { leaveUnit: i18n.language === "gr" ? oasisParam.leaveUnit === "H" ? "ώρες" : "ημέρες" : oasisParam.leaveUnit === "H" ? "hours" : "days" })}
                                type='AVAILABLEUSED' />}
                        <SafeAreaView style={styles.circleView}>
                            {Platform.OS === 'android' ?
                                <Progress.Circle
                                    animated={false}
                                    progress={leavePercent.toFixed(0) / 100}
                                    size={height * 10 / 100}
                                    borderWidth={1}
                                    textStyle={styles.circle}
                                    showsText={true}
                                    color={item.colour.toLowerCase()} />
                                :
                                <CustomProgressCircle
                                    percent={leavePercent.toFixed(0)}
                                    bgRingWidth={15}
                                    progressRingWidth={15}
                                    radius={50}
                                    textFontSize={16}
                                    ringColor={item.colour.toLowerCase()}
                                    textFontColor={colors.text_primary} />}
                        </SafeAreaView>
                    </Pressable>
                </SafeAreaView>
                {showDetails == true &&
                    <SafeAreaView style={styles.columnRight}>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:YearlyAllowance') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.yearlyAllowance}
                                    type='LEAVEDETAILSMINOR' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:BroughtFoward') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.broughtforward}
                                    type='LEAVEDETAILSMINOR' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:LeaveTaken') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.taken}
                                    type='LEAVEDETAILSMINOR' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={isAlphaMega ? t('common:CurrAllowanceEOY') + `:` : t('common:CurrAllowance') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.remaining}
                                    type='LEAVEDETAILSMINOR' />
                            </View>
                        </SafeAreaView>
                    </SafeAreaView>
                }
            </View>
        );
    }

    const renderData = (employeeName, list) => {
        const isExpanded = expandedSections.has(employeeName);

        if (!isExpanded)
            return null;
        return (
            <FlatList
                data={list}
                numColumns={2}
                renderItem={({ item }) => {
                    if (item.updhol === true) {
                        return (
                            <Card style={styles.flatlistCard} >
                                <Card.Title
                                    title={item.acodeDesc}
                                    titleStyle={styles.textMain}
                                    titleNumberOfLines={2}
                                />
                                <Card.Content>
                                    <SafeAreaView>
                                        <ShowHideMenu {...item} />
                                    </SafeAreaView>
                                </Card.Content>
                            </Card >
                        )
                    }
                }}
            />
        )

    }

    const renderDataWeb = (item) => {
        if (item.updhol === true) {
            return (
                <Card style={styles.flatlistCard} >
                    <Card.Title
                        title={item.acodeDesc}
                        titleStyle={styles.textMain}
                        titleNumberOfLines={2}
                    />
                    <Card.Content>
                        <SafeAreaView>
                            <ShowHideMenu {...item} />
                        </SafeAreaView>
                    </Card.Content>
                </Card >
            )
        }
    }
    //#endregion

    //#region Function Use Effect
    useEffect(() => {
        // Create Async Function 
        const onGetTeamsLeaveAnalysis = async () => {
            await GetTeamsLeaveAnalysis()
        }
        // Call Async Function
        onGetTeamsLeaveAnalysis()
            // make sure to catch any error
            .catch(console.error);
    }, [])
    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    // navigation
    useEffect(() => {
        navigation.setOptions({
            title: t('navigate:TB')
        });
    }, []);
    //#endregion
    if (loading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )

    return (
        <SafeAreaView style={styles.mainView}>
            <SafeAreaView style={styles.rowView}>
                <SafeAreaView style={styles.subMain}>
                    <CustomLabel
                        value={t('navigate:TB')}
                        type='MINORTITLE'
                    />
                    <SectionList
                        sections={data}
                        initialNumToRender={30}
                        renderItem={({ item, index, section }) => (
                            (Platform.OS === 'web' && width > 1200) ? <></> : renderData(section.employeeName, item)
                        )}
                        onRefresh={() => GetTeamsLeaveAnalysis()}
                        refreshing={loading}
                        contentContainerStyle={{
                            paddingHorizontal: 10,
                        }}
                        stickySectionHeadersEnabled={false}
                        keyExtractor={(item, index) => item + index}
                        renderSectionHeader={({ section: { employeeName, photograph } }) => (
                            <Card style={employeeName === selectedTitle ? [styles.border, styles.cardstyle] : [styles.cardstyle]} >
                                <Pressable onPress={() => handleToggle(employeeName)}>
                                    <SafeAreaView style={styles.row}>
                                        <Image
                                            style={{
                                                width: 30,
                                                height: 30,
                                                marginVertical: '1%',
                                                marginRight: '3%',
                                                borderRadius: 100,
                                                borderWidth: 1,
                                                alignSelf: 'center',
                                            }}
                                            source={{ uri: `data:image/png;base64,${photograph === undefined || photograph === '' ? DEFAULTPROFILE : photograph}` }}
                                        />
                                        <CustomLabel
                                            value={employeeName}
                                            type='MAJOR'
                                        />
                                    </SafeAreaView>
                                </Pressable>
                            </Card>
                        )}
                    />
                </SafeAreaView>
                {(Platform.OS === 'web' && width > 1200) && <SafeAreaView style={styles.subMain}>
                    <CustomLabel
                        type='MINORTITLE'
                    />
                    <FlatList
                        data={teamMemberData[0]}
                        numColumns={2}
                        renderItem={({ item }) => {
                            return renderDataWeb(item);
                        }}
                    />

                </SafeAreaView>
                }
            </SafeAreaView>
        </SafeAreaView>
    )
};

const makeStyles = (colors, width, height) => StyleSheet.create({
    mainView: {
        flex: 1,
        marginRight: Platform.OS === 'web' ? '3%' : 15,
        marginLeft: Platform.OS === 'web' ? '3%' : 0,
        //marginRight: '5%',
    },
    circle: {
        color: colors.text_primary,
        fontWeight: 'bold',
    },
    loader: {
        padding: 80
    },
    subMain: {
        flex: 1,
        justifyContent: 'felx-start',
        paddingLeft: Platform.OS === 'web' ? 10 : 5,
        marginTop: Platform.OS === 'web' ? 10 : 5,
    },
    rowView: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
    },
    border: {
        borderColor: colors.buttons_primary,
        borderWidth: 1,
    },
    cardstyle: {
        flex: 1,
        width: (Platform.OS !== 'web') ? width * 0.85 : (width > 1200 ? width * 0.35 : width * 0.75), //alternative so that halfscreen also works 
        // width: (Platform.OS === 'web' && width > 1300) ? width * 0.35 : width * 0.80,
        paddingLeft: 10,
        paddingRight: 1,
        marginVertical: 10,
        borderRadius: 5,
        elevation: 3,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
    },
    flatlistCard: {
        flex: 1,
        width: (Platform.OS !== 'web') ? width * 0.95 : (width > 1200 ? width * 0.35 : width * 0.70),
        //width: (Platform.OS === 'web' && width < 1300) ? width * 0.5 : 'auto',
        // maxWidth: (Platform.OS === 'web' && width > 1300) ? 1080 * 0.4 : 'auto',
        marginVertical: 10,
        paddingRight: Platform.OS !== 'web' ? 15 : 0,
        marginHorizontal: Platform.OS === 'web' ? 10 : 0,
        borderRadius: 35,
        elevation: 3,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
    },
    showhide: {
        flex: 1,
        borderRadius: 35,
        backgroundColor: colors.background_card,
        flexDirection: 'row',
        alignItems: 'center',
    },
    row: {
        flex: 1,
        flexDirection: "row",
        alignItems: 'center',
    },
    column: {
        flex: 1,
        alignItems: "center",
    },

    columnLeft: {
        flex: 1,
        justifyContent: 'flex-start',
    },

    columnRight: {
        marginLeft: '3%',
        flex: 1,
        justifyContent: 'flex-end',
    },

    circleView: {
        paddingTop: '10%',
        alignItems: "center",
    },
    textMain: {
        fontSize: Platform.OS === 'web' ? 18 : 14,
        fontWeight: 'bold',
        color: colors.text_primary,
        alignItems: 'center',
        justifyContent: 'center'
    },
    line: {
        borderBottomColor: colors.buttons_primary,
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginTop: "5%",
        marginBottom: "5%",
    },
    // item: {
    //     width: '100%'
    // },
});

export default TeamsLeaveBalancesScreen;